import * as React from 'react';
import { hot } from 'react-hot-loader';
import { Provider } from 'react-redux';
import './common/setup';
import { configureStore } from './common/store';
import { AdsCheckout } from './modules/ads-checkout';

const store = configureStore();

class App extends React.Component {
  render() {
    return (
      <Provider store={store}>
        <AdsCheckout />
      </Provider>
    );
  }
}

export default hot(module)(App);



// WEBPACK FOOTER //
// ./src/App.tsx